// This file initializes and exports all necessary Firebase services.

// --- Firebase Imports ---
import { initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { connectStorageEmulator, getStorage } from 'firebase/storage'

// --- Firebase Config ---
const DEVELOPMENT_FirebaseConfig = {
  apiKey: 'AIzaSyAT81L_gsi3PWwxiz1FpoiUD54aYYhrkj8',
  authDomain: 'finalytics-development.firebaseapp.com',
  projectId: 'finalytics-development',
  storageBucket: 'finalytics-development.firebasestorage.app',
  messagingSenderId: '334725384863',
  appId: '1:334725384863:web:69d07127690da125c630aa',
}
const PRODUCTION_FirebaseConfig = {
  apiKey: 'AIzaSyB9_J1AZkSbCM9v3PeV4m33qojHX51bLwg',
  authDomain: 'finalytics-62350.firebaseapp.com',
  projectId: 'finalytics-62350',
  storageBucket: 'finalytics-62350.firebasestorage.app',
  messagingSenderId: '586305419053',
  appId: '1:586305419053:web:b94a325fd5b649340305a4',
}

const knownProductionHostnames = ['finalytics.id', 'www.finalytics.id', 'app.finalytics.id']
const isProduction = true
const currentFirebaseConfig = isProduction
  ? PRODUCTION_FirebaseConfig
  : DEVELOPMENT_FirebaseConfig

const parsePort = (port: string | undefined, fallback: number): number => {
  const parsed = Number(port)
  return Number.isFinite(parsed) ? parsed : fallback
}

const useFirebaseEmulators = import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true'
const emulatorHost = import.meta.env.VITE_FIREBASE_EMULATOR_HOST ?? '127.0.0.1'
const authEmulatorPort = parsePort(import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_PORT, 9099)
const firestoreEmulatorPort = parsePort(import.meta.env.VITE_FIREBASE_FIRESTORE_EMULATOR_PORT, 8080)
const functionsEmulatorPort = parsePort(import.meta.env.VITE_FIREBASE_FUNCTIONS_EMULATOR_PORT, 5001)
const storageEmulatorPort = parsePort(import.meta.env.VITE_FIREBASE_STORAGE_EMULATOR_PORT, 9199)
const functionsRegion = 'us-central1'

console.debug(
  'Firebase is running in '
  + (isProduction ? 'PRODUCTION' : 'DEVELOPMENT')
  + ` environment${useFirebaseEmulators ? ' with local emulators' : ''}.`,
)

// --- Initialize and Export Firebase Services ---
export const app = initializeApp(currentFirebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)
export const functions = getFunctions(app, functionsRegion)
export const storage = getStorage(app)

if (useFirebaseEmulators) {
  connectAuthEmulator(auth, `http://${emulatorHost}:${authEmulatorPort}`, { disableWarnings: true })
  connectFirestoreEmulator(db, emulatorHost, firestoreEmulatorPort)
  connectFunctionsEmulator(functions, emulatorHost, functionsEmulatorPort)
  connectStorageEmulator(storage, emulatorHost, storageEmulatorPort)
  console.info(
    `Firebase services connected to local emulators at ${emulatorHost} `
    + `(auth:${authEmulatorPort}, firestore:${firestoreEmulatorPort}, functions:${functionsEmulatorPort}, storage:${storageEmulatorPort}).`,
  )
}
